import { PriceTable } from 'src/features/homeowners/components/price-table/price-table';
import { useStore } from 'src/store';
import { regionIdSelector } from 'src/store/region';

export function HomeownersPriceTableSlice(): JSX.Element {
  const selectedRegionId = useStore(regionIdSelector);

  return (
    <div className="w-full">
      <PriceTable regionId={selectedRegionId} from="default" />
    </div>
  );
}
